import { useKeycloak } from '@react-keycloak/web';
import { useSelector } from "react-redux";
import { Formio } from '@formio/js';
import { FORMIO_TOKEN_BASE_URL_KEY } from '../components/formio/FormioProvider';

export const useAuth = () => {
  const { keycloak } = useKeycloak();
  const { currentLanguage } = useSelector(state => state.translations);
  //const login = () => keycloak.login();
  const login = (locale) => {
    const loginOptions = {
      redirectUri: window.location.href,
    };

    if (locale) {
      loginOptions.locale = locale;
    } else {
      if (currentLanguage) {
        loginOptions.locale = currentLanguage;
      }
    }

    // Only pass options if there are any
    return Object.keys(loginOptions).length > 1
      ? keycloak.login(loginOptions)
      : keycloak.login({ redirectUri: window.location.href });
  };

  const createLoginUrl = (redirectUri, lang) => {
    const createLoginUrlOptions = {};
    const { currentLanguage } = useSelector(state => state.translations);
    // Add redirectUri if provided
    if (redirectUri) {
      createLoginUrlOptions.redirectUri = redirectUri;
    } else {
      // Default to current page
      createLoginUrlOptions.redirectUri = window.location.href;
    }

    // Add locale if provided
    if (lang) {
      createLoginUrlOptions.locale = lang;
    } else {
      // Try to use saved language
      //const savedLanguage = localStorage.getItem('language');
      if (currentLanguage) {
        createLoginUrlOptions.locale = currentLanguage;
      }
    }

    return keycloak.createLoginUrl(createLoginUrlOptions);
  };
  const logout = () => {
    // Clear Form.io's own cached token too - it's independent of the Keycloak session,
    // so without this a stale token would otherwise survive logout (see FormioProvider.jsx).
    Formio.setToken(null);
    localStorage.removeItem(FORMIO_TOKEN_BASE_URL_KEY);
    return keycloak.logout({ redirectUri: window.location.origin+"/login" });
  };
  const register = () => keycloak.register();

  const hasRole = (role) => keycloak.hasRealmRole(role);
  const hasAnyRole = (roles) => roles.some(role => keycloak.hasRealmRole(role));

  const getUser = () => {
    if (!keycloak.authenticated) return null;

    const allRoles = keycloak.realmAccess?.roles || [];

    // Filter out built-in roles
    const customRoles = allRoles.filter(role =>
      role !== 'default-roles-restaurant' &&
      role !== 'offline_access' &&
      role !== 'uma_authorization'
    );

    return {
      id: keycloak.tokenParsed?.sub,
      username: keycloak.tokenParsed?.preferred_username,
      email: keycloak.tokenParsed?.email,
      firstName: keycloak.tokenParsed?.given_name,
      lastName: keycloak.tokenParsed?.family_name,
      roles: customRoles
    };
  };

  const getToken = () => keycloak.token;

  const refreshToken = () => keycloak.updateToken(30);

  return {
    // State
    isAuthenticated: keycloak.authenticated,
    isLoading: !keycloak.didInitialize,

    // User info
    user: getUser(),
    token: getToken(),

    // Actions
    login,
    logout,
    register,
    refreshToken,
    createLoginUrl,
    // Role checking
    hasRole,
    hasAnyRole,

    // Raw keycloak instance (if needed)
    keycloak
  };
};

export default useAuth;